import apiClient from '../apiClient';
import { GET_INVOICES_BY_TRANSACTION_ID_URL } from '../apiUrl';

const getInvoiceHistoryByTransactionIdApi = Id => {
  return apiClient.get(GET_INVOICES_BY_TRANSACTION_ID_URL(Id));
};

export default getInvoiceHistoryByTransactionIdApi;
